import { parseProviderSources } from '../constants';
import type { GPV6TemplateType, TemplateInfo, ProviderSource } from '../types/template';
import { TemplateType } from '../types/template';

export const parseIdTemplate = (assetKey: string, providerSource: ProviderSource): string | undefined => {
  const source = getProviderSourceParser(providerSource);
  if (!source?.regexId) return;

  const match = source.regexId?.exec(assetKey);
  if (match?.length && match[1]) {
    return match[1];
  }
};

export const getProviderSourceParser = (providerSource?: ProviderSource) => {
  if (!providerSource) return;

  const providerSourceInfo = parseProviderSources.find((source) => source.providerSource === providerSource);
  return providerSourceInfo;
};

export const parseTemplateInfoBy = ({ templateSuffix }: { templateSuffix?: string }): TemplateInfo | undefined => {
  if (!templateSuffix) return;

  let templateInfo: TemplateInfo | undefined = undefined;
  for (const source of parseProviderSources) {
    templateInfo = source.parseTemplate({
      assetKey: templateSuffix,
      providerSourceInfo: source,
    });
    if (templateInfo) break;
  }

  return templateInfo;
};

export function convertTemplateTypeToGPV6(type: TemplateType): GPV6TemplateType | undefined {
  switch (type) {
    case TemplateType.COLLECTION:
      return 'template-collection';
    case TemplateType.PRODUCT:
      return 'template-product';
    case TemplateType.HOME:
      return 'template-index';
    case TemplateType.BLOG:
    case TemplateType.ARTICLE:
      return 'template-article';
    case TemplateType.PAGE:
      return 'template-page';
    default:
      return 'template-page';
  }
}

export const getTemplateSuffix = (pageType: string, idPageTemplate: string) => {
  if (!idPageTemplate) return '';
  let shopifyResourceType = 'page';
  if (pageType === 'template-product') {
    shopifyResourceType = 'product';
  } else if (pageType === 'template-collection') {
    shopifyResourceType = 'collection';
  } else if (pageType === 'template-index') {
    shopifyResourceType = 'index';
  } else if (pageType === 'template-article') {
    shopifyResourceType = 'article';
  }
  return `templates/${shopifyResourceType}.gem-${idPageTemplate}-template.liquid`;
};
